import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpAlarmEventData implements IOpData {
    //Properties
    public idAlarmEventData: number
    public idAlarmEvent: number
    public idDataType: number
    public indexNbr: number
    public value: any
    //Properties end

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    constructor(opObj: any) {
       this.fromJSON(opObj)
    }

    //IOpData implementation
    public get idData() { return this.idAlarmEventData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    //get value() { return this.value }
    //IOpData implementation end

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idAlarmEventData = opObj.IdAlarmEventData
            this.idAlarmEvent = opObj.IdAlarmEvent
            this.idDataType = opObj.IdDataType
            this.indexNbr = opObj.IndexNbr
            this.value = opObj.Value

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            IdAlarmEventData: this.idAlarmEventData,
            IdAlarmEvent: this.idAlarmEvent,
            IdDataType: this.idDataType,
            IndexNbr: this.indexNbr,
            Value: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpAlarmEventData {
        const newData: OpAlarmEventData = new OpAlarmEventData(null)

        newData.idAlarmEventData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
}